/* WSC-06: consent-gated first-party observations. Activation follows collector deployment. */
(function(window,document){
  'use strict';
  if(window.wsFunnelAnalytics)return;
  const UUID=/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const SUBJECT=['style','category','compositionMode'];
  const ATTEMPT=['attemptId','attemptOrdinal','retryKind'];
  const JOB=['asyncJobId','wsJobId'];
  const TIME=['elapsedMs','httpStatus'];
  const CART=['material','size'];
  const fields={
    landing_view:['landingSurface','source','medium','campaignKey'],generator_interaction:SUBJECT,
    photo_uploaded:[...SUBJECT,'slotCount'],upload_rejected:[...SUBJECT,'reason'],
    generate_clicked:[...SUBJECT,...ATTEMPT,'slotCount'],
    generation_response_received:[...SUBJECT,...ATTEMPT,...JOB,...TIME],
    generate_failed:[...SUBJECT,...ATTEMPT,...JOB,...TIME,'reason'],
    preview_rendered:[...SUBJECT,...ATTEMPT,...JOB,'elapsedMs'],
    preview_render_failed:[...SUBJECT,...ATTEMPT,...JOB,'elapsedMs','reason'],
    material_size_selected:[...SUBJECT,'wsJobId',...CART],add_to_cart_attempt:[...SUBJECT,'wsJobId',...CART],
    add_to_cart_success:[...SUBJECT,'wsJobId',...CART,...TIME],add_to_cart_error:[...SUBJECT,'wsJobId',...CART,...TIME,'reason'],
    checkout_click:['wsJobId']
  };
  const enums={
    style:['royal','popart','watercolor','baroque','anime','nordic','lineart','superhero','vintage_fashion','world_cup_football'],
    category:['huisdier','zelf','gezin','kind','koppel'],compositionMode:['mixed_single_photo'],retryKind:['fresh_render','text_edit'],
    material:['digital','poster','canvas','glass'],size:['s','m','l'],landingSurface:['home','portrait','oranje','other'],
    source:['meta','google','direct','other','unknown'],medium:['paid_social','paid_search','organic','referral','direct','other','unknown'],
    campaignKey:['ws_tof_petportrait','ws_wk_oranje','unknown']
  };
  const reasons={upload_rejected:['invalid_file','file_too_large','too_many_files','image_decode_failed'],
    generate_failed:['parse_error','network_error','timeout','provider_rejected','preparation_failed','cancelled','http_error','invalid_response'],
    preview_render_failed:['image_load_failed','image_decode_failed'],
    add_to_cart_error:['preview_required','variant_unavailable','network_error','timeout','http_error','invalid_response']};
  const bounds={attemptOrdinal:[1,9999],elapsedMs:[0,600000],httpStatus:[100,599],slotCount:[1,3]};
  const STORAGE='ws_funnel_journey_v1';
  let epoch=0,allowed=false,journey=null,journeyExpires=0,serial=0,watch=null,started=false,landingRecorded=false,reuseStoredJourney=true;
  const attempts=new Map(),jobs=new Map(),rendered=new Set(),requests=new Set();
  function clear(){
    epoch++;journey=null;journeyExpires=0;attempts.clear();jobs.clear();rendered.clear();
    if(watch)watch();
    requests.forEach(controller=>controller.abort());requests.clear();
    try{window.sessionStorage.removeItem(STORAGE);}catch(_){}
  }
  function permission(){
    let next=false;
    try{next=window.WS_FUNNEL_EVENTS_ENABLED===true&&window.Shopify.customerPrivacy.analyticsProcessingAllowed()===true;}catch(_){}
    if((allowed&&!next)||(next&&journey&&Date.now()>=journeyExpires))clear();
    if(!next)reuseStoredJourney=false;
    allowed=next;
    return next;
  }
  function capture(){return permission()?epoch:null;}
  function validEpoch(value){return permission()&&value!==null&&value===epoch;}
  function uuid(){
    if(typeof window.crypto.randomUUID==='function')return window.crypto.randomUUID();
    const bytes=new Uint8Array(16);window.crypto.getRandomValues(bytes);bytes[6]=(bytes[6]&15)|64;bytes[8]=(bytes[8]&63)|128;
    const hex=Array.from(bytes,b=>b.toString(16).padStart(2,'0')).join('');
    return hex.slice(0,8)+'-'+hex.slice(8,12)+'-'+hex.slice(12,16)+'-'+hex.slice(16,20)+'-'+hex.slice(20);
  }
  function journeyId(){
    if(journey)return journey;
    try{const saved=reuseStoredJourney?JSON.parse(window.sessionStorage.getItem(STORAGE)||'null'):null;
      if(saved&&UUID.test(saved.id)&&Number.isFinite(saved.at)&&Date.now()-saved.at>=0&&Date.now()-saved.at<86400000){journey=saved.id;journeyExpires=saved.at+86400000;}
    }catch(_){}
    if(!journey){journey=uuid();journeyExpires=Date.now()+86400000;try{window.sessionStorage.setItem(STORAGE,JSON.stringify({id:journey,at:Date.now()}));}catch(_){}}
    return journey;
  }
  function project(name,input){
    if(!Object.hasOwn(fields,name))return null;
    const out={};
    for(const key of fields[name]){
      const value=input&&input[key];
      if(value===undefined||value===null)continue;
      if(enums[key]){if(enums[key].includes(value))out[key]=value;}
      else if(bounds[key]){if(Number.isInteger(value)&&value>=bounds[key][0]&&value<=bounds[key][1])out[key]=value;}
      else if(key==='reason'){if(reasons[name]&&reasons[name].includes(value))out[key]=value;}
      else if(['attemptId','asyncJobId','wsJobId'].includes(key)&&typeof value==='string'&&UUID.test(value))out[key]=value;
    }
    if(reasons[name]&&!out.reason)return null;
    if(['generate_clicked','generation_response_received'].includes(name)&&!out.attemptId)return null;
    if(name==='generation_response_received'&&!out.asyncJobId&&!out.wsJobId)return null;
    if(['preview_rendered','preview_render_failed','add_to_cart_success'].includes(name)&&!out.wsJobId)return null;
    if((name==='material_size_selected'||name.startsWith('add_to_cart_'))&&!out.material)return null;
    if(out.material==='digital')delete out.size;
    const preflight=name==='add_to_cart_attempt'||(name==='add_to_cart_error'&&['preview_required','variant_unavailable'].includes(out.reason));
    if(out.material&&out.material!=='digital'&&!out.size&&!preflight)return null;
    return out;
  }
  function record(name,input,origin){
    try{
      if(origin===undefined)origin=capture();
      if(!validEpoch(origin))return false;
      const detail=project(name,input);if(!detail)return false;
      const event={schemaVersion:1,eventId:uuid(),journeyId:journeyId(),name,occurredAt:new Date().toISOString(),analyticsConsent:'allowed',...detail};
      const body=JSON.stringify(event);if(new TextEncoder().encode(body).length>4096||!validEpoch(origin))return false;
      if(requests.size>=20)return false;
      const controller=new AbortController();requests.add(controller);
      const timeout=setTimeout(()=>controller.abort(),5000);
      // No retry queue: a failed or ambiguous send remains unknown coverage.
      Promise.resolve().then(()=>{if(!validEpoch(origin))return;return window.fetch('/apps/wallstraight/ai/events',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body,keepalive:true,signal:controller.signal});})
        .catch(()=>{}).finally(()=>{clearTimeout(timeout);requests.delete(controller);});
      return true;
    }catch(_){return false;}
  }
  function boundedSet(map,key,value){map.set(key,value);while(map.size>20)map.delete(map.keys().next().value);}
  function beginAttempt(detail){
    try{const origin=capture();if(origin===null)return null;
      const handle=++serial,ctx={epoch:origin,at:Date.now(),detail:{...project('generator_interaction',detail),attemptId:uuid()}};
      if(enums.retryKind.includes(detail&&detail.retryKind))ctx.detail.retryKind=detail.retryKind;
      boundedSet(attempts,handle,ctx);
      record('generate_clicked',{...ctx.detail,slotCount:detail&&detail.slotCount},origin);return handle;
    }catch(_){return null;}
  }
  function attemptEvent(handle,name,detail){
    const ctx=attempts.get(handle);if(!ctx||!validEpoch(ctx.epoch))return false;
    const elapsedMs=Date.now()-ctx.at;
    if(detail&&UUID.test(detail.wsJobId||''))boundedSet(jobs,detail.wsJobId,ctx);
    return record(name,{...ctx.detail,elapsedMs,...detail},ctx.epoch);
  }
  function ordinal(handle,value,retryKind){const ctx=attempts.get(handle);if(ctx&&validEpoch(ctx.epoch)){ctx.detail.attemptOrdinal=value;ctx.detail.retryKind=retryKind;}}
  function requestSubject(handle,subject){
    const ctx=attempts.get(handle);if(!ctx||!validEpoch(ctx.epoch))return;
    SUBJECT.forEach(key=>{delete ctx.detail[key];});Object.assign(ctx.detail,project('generator_interaction',subject));
  }
  function bindJob(handle,jobId){if(handle===undefined||capture()===null||!UUID.test(jobId||''))return;const ctx=attempts.get(handle);boundedSet(jobs,jobId,ctx&&ctx.epoch===epoch?ctx:{epoch:null});}
  function observePreview(el,url,jobId,subject,isCurrent){
    try{
      const origin=capture();if(origin===null||!el||!UUID.test(jobId||''))return;
      const prior=jobs.get(jobId);if(prior&&prior.epoch!==origin)return;
      if(watch)watch();
      let stopped=false,decoded=false,decoding=false,io=null,mo=null;
      const ctx=jobs.get(jobId),detail={...subject,...(ctx&&ctx.epoch===origin?ctx.detail:{}),wsJobId:jobId};
      const current=()=>!stopped&&validEpoch(origin)&&el.src===url&&isCurrent();
      const visible=()=>{
        if(document.visibilityState!=='visible'||!el.isConnected||!el.complete||!(el.naturalWidth>0))return false;
        for(let node=el;node;node=node.parentElement){const css=window.getComputedStyle(node);if(css.visibility==='hidden'||css.display==='none'||Number(css.opacity)===0)return false;}
        const rect=el.getBoundingClientRect();
        return rect.width>0&&rect.height>0&&rect.bottom>0&&rect.right>0&&rect.top<window.innerHeight&&rect.left<window.innerWidth;
      };
      const cleanup=()=>{stopped=true;el.removeEventListener('load',load);el.removeEventListener('error',error);document.removeEventListener('visibilitychange',check);window.removeEventListener('scroll',check);window.removeEventListener('resize',check);if(io)io.disconnect();if(mo)mo.disconnect();if(watch===cleanup)watch=null;};
      const check=()=>{if(!current()||rendered.has(jobId)){cleanup();return;}if(!decoded)return;
        window.requestAnimationFrame(()=>{if(current()&&decoded&&visible()&&!rendered.has(jobId)){
          if(ctx)detail.elapsedMs=Date.now()-ctx.at;
          if(record('preview_rendered',detail,origin)){rendered.add(jobId);if(rendered.size>100)rendered.delete(rendered.values().next().value);}cleanup();
        }});
      };
      const fail=reason=>{if(current())record('preview_render_failed',{...detail,reason},origin);cleanup();};
      const load=()=>{if(decoding||stopped)return;decoding=true;
        Promise.resolve().then(()=>{if(!current())return false;return typeof el.decode==='function'?el.decode().then(()=>true):el.complete&&el.naturalWidth>0;})
          .then(ok=>{decoding=false;if(ok){decoded=true;check();}}).catch(()=>{decoding=false;fail('image_decode_failed');});
      };
      const error=()=>{if(current())fail('image_load_failed');};
      watch=cleanup;el.addEventListener('load',load);el.addEventListener('error',error);
      document.addEventListener('visibilitychange',check);window.addEventListener('scroll',check,{passive:true});window.addEventListener('resize',check);
      if(typeof window.IntersectionObserver==='function'){io=new window.IntersectionObserver(check);io.observe(el);}
      if(typeof window.MutationObserver==='function'){mo=new window.MutationObserver(check);const parent=el.closest('#resPage');if(parent)mo.observe(parent,{attributes:true,attributeFilter:['class','style']});}
      // The caller sets src synchronously; observe decode independently of its UX timeout.
      Promise.resolve().then(load);
    }catch(_){if(watch)watch();}
  }
  function failureReason(error,phase){
    if(error&&error.name==='AbortError')return 'cancelled';
    if(phase==='preparation')return 'preparation_failed';
    if(error&&error.code==='poll_timeout')return 'timeout';
    if(error&&['invalid_json','non_json_response'].includes(error.code))return 'parse_error';
    if(error&&error.code==='billing_upstream')return 'provider_rejected';
    if(error&&Number.isInteger(error.status)&&error.status>=400)return 'http_error';
    return phase==='request'?'network_error':'invalid_response';
  }
  function cancelPreview(){if(watch)watch();}
  function landing(){
    if(landingRecorded||capture()===null)return;
    const path=window.location.pathname.toLowerCase(),query=new URLSearchParams(window.location.search);
    const rawSource=(query.get('utm_source')||'').toLowerCase(),rawMedium=(query.get('utm_medium')||'').toLowerCase();
    const direct=!rawSource&&!document.referrer;
    const source=['facebook','instagram','fb','ig','meta'].includes(rawSource)?'meta':rawSource==='google'?'google':direct?'direct':rawSource?'other':'unknown';
    const medium=['paidsocial','paid_social','paid-social'].includes(rawMedium)?'paid_social':rawMedium==='cpc'?(source==='meta'?'paid_social':source==='google'?'paid_search':'other'):['paid_search','organic','referral'].includes(rawMedium)?rawMedium:direct?'direct':rawMedium?'other':'unknown';
    const rawCampaign=query.get('utm_campaign');
    landingRecorded=record('landing_view',{landingSurface:path.includes('oranje')?'oranje':path==='/'?'home':path.includes('portrait')||path.includes('portret')?'portrait':'other',source,medium,campaignKey:enums.campaignKey.includes(rawCampaign)?rawCampaign:'unknown'});
  }
  function start(){
    if(started||window.WS_FUNNEL_EVENTS_ENABLED!==true)return;started=true;
    document.addEventListener('visitorConsentCollected',()=>{permission();});
    try{if(window.Shopify&&window.Shopify.customerPrivacy){permission();landing();}
      else if(window.Shopify&&typeof window.Shopify.loadFeatures==='function')window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error){permission();landing();}});
    }catch(_){}
  }
  window.wsFunnelAnalytics={record,capture,beginAttempt,attemptEvent,ordinal,requestSubject,bindJob,observePreview,cancelPreview,failureReason,start};
  start();
})(window,document);
